module.exports = __webpack_public_path__ + "img/86.256db26.svg";